
























import { Vue, Component, Prop } from 'vue-property-decorator'
import EditForm from '@/components/EditForm.vue'

const fields = 'id friendly sku'

@Component({ components: { EditForm }})
export default class ProductForm extends Vue {

	@Prop() product

	defaultProduct = {
		id: '',
		friendly: '',
		sku: ''
	}

	createProduct = `mutation CreateProduct($input: ProductInput!) {
		createProduct(input: $input) { ${ fields } }
	}`
	updateProduct = `mutation UpdateProduct($input: ProductInput!) {
		updateProduct(input: $input) { ${ fields } }
	}`
	deleteProduct = `mutation DeleteProduct($id: ID!) {
		deleteProduct(id: $id) { ${ fields } }
	}`

}
